export enum MenuAction{

    toggle,
    close,
    open,

}